import type { IxcRegistrationV1Address } from '@interxfi/types';
import { exhaustiveCheck } from '@interxfi/utilities/types/exhaustive';

type FormatUSAddressLayout = 'one-line' | 'two-line' | 'variable-line';

type AddressFormatLayouts = {
  usAddress: FormatUSAddressLayout;
};

const DEFAULT_ADDRESS_FORMAT_LAYOUTS: AddressFormatLayouts = {
  usAddress: 'variable-line',
};

export const ONE_LINE_ADDRESS_FORMAT_LAYOUTS: AddressFormatLayouts = {
  usAddress: 'one-line',
};

export function formatAddress(address: IxcRegistrationV1Address | undefined, layouts: AddressFormatLayouts = DEFAULT_ADDRESS_FORMAT_LAYOUTS) {
  if (!address) {
    return '';
  }

  if ('usAddress' in address) {
    const cityStateAndZip = [[address.usAddress.city, address.usAddress.state].filter(Boolean).join(', '), address.usAddress.postalCode]
      .filter(Boolean)
      .join(' ');

    switch (layouts.usAddress) {
      case 'one-line':
        return [address.usAddress.street1, address.usAddress.street2, cityStateAndZip].filter(Boolean).join(', ');
      case 'two-line':
        return [[address.usAddress.street1, address.usAddress.street2].filter(Boolean).join(', '), cityStateAndZip].filter(Boolean).join('\n');
      case 'variable-line':
        return [address.usAddress.street1, address.usAddress.street2, cityStateAndZip].filter(Boolean).join('\n');
      default:
        return '';
    }
  }

  exhaustiveCheck(address);

  return '';
}
